<div id="dashboard" class="screen bg-station-cream min-h-screen">
  <div class="bg-white border-b border-border-subtle mb-8">
    <div class="max-w-7xl mx-auto px-4 md:px-6 py-8">
      <!-- Header -->
      <div class="mb-6">
        <h1 class="text-3xl md:text-4xl font-bold mb-2">My Boards</h1>
        <p class="text-rail-gray">Manage and share your split-flap displays</p>
      </div>

      <!-- Action buttons -->
      <button
        (click)="createBoard()"
        class="px-6 py-3 bg-signal-orange text-white rounded-lg font-semibold hover:bg-signal-orange/90 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-signal-orange/30 transition-all cursor-pointer"
      >
        + New Board
      </button>
    </div>
  </div>

  <div class="max-w-7xl mx-auto px-4 md:px-6 pb-8">
    <!-- Loading state -->
    @if (isLoading()) {
      <div class="text-center py-16">
        <div
          class="w-16 h-16 border-4 border-signal-orange border-t-transparent rounded-full animate-spin mx-auto mb-4"
        ></div>
        <p class="text-rail-gray">Loading your boards...</p>
      </div>
    }

    <!-- Error state -->
    @else if (error()) {
      <div class="text-center py-16">
        <div class="text-6xl mb-4">⚠️</div>
        <h2 class="text-2xl font-bold text-flap-black mb-2">Something went wrong</h2>
        <p class="text-rail-gray mb-6">{{ error() }}</p>
        <button
          (click)="loadBoards()"
          class="px-6 py-3 bg-signal-orange text-white rounded-lg font-semibold hover:bg-signal-orange/90 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-signal-orange/30 transition-all cursor-pointer"
        >
          Try Again
        </button>
      </div>
    }

    <!-- Boards grid -->
    @else if (boards().length > 0) {
      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        @for (board of boards(); track board.id) {
          <app-board-card
            [board]="board"
            (copyUrl)="onCopyUrl($event)"
            (edit)="onEdit($event)"
            (preview)="onPreview($event)"
            (openInNewWindow)="onOpenInNewWindow($event)"
            (delete)="onDelete($event)"
          />
        }
      </div>
    }

    <!-- Empty state -->
    @else {
      <div class="text-center py-16">
        <div class="text-6xl mb-4">📋</div>
        <h2 class="text-2xl font-bold text-flap-black mb-2">No boards yet</h2>
        <p class="text-rail-gray mb-6">
          Create your first split-flap board to get started
        </p>
        <button
          (click)="createBoard()"
          class="px-6 py-3 bg-signal-orange text-white rounded-lg font-semibold hover:bg-signal-orange/90 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-signal-orange/30 transition-all cursor-pointer"
        >
          + Create Your First Board
        </button>
      </div>
    }
  </div>
</div>
